import { $getRoot, ElementNode, TextNode } from "lexical";
const getAllTextContent = (editorState)=>{
    let text = '';
    editorState.read(()=>{
        const visit = (node)=>{
            if (node instanceof TextNode) text += `${node.getTextContent()} `;
            else if ('getTextContent' in node && 'function' == typeof node.getTextContent && 'root' !== node.getType()) text += `${node.getTextContent()} `;
            else if (node instanceof ElementNode) node.getChildren().forEach((child)=>visit(child));
        };
        visit($getRoot());
    });
    return text.trim();
};
export { getAllTextContent };
